// @flow
import $ from 'jquery';
import JQueryView, { on } from './JQueryView';
import { color } from '../../styles/theme';

export default class SquareTable extends JQueryView {
  constructor() {
    super('.square-table');
  }

  @on({ event: 'click', selector: 'tr[data-href]' })
  click(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.location = $(e.currentTarget).data('href');
  }

  @on({ event: 'click', selector: 'td[data-href]' })
  onClickTd(e: any) {
    const isLink = $(e.target).hasClass('link');
    if (isLink) return;
    window.location = $(e.currentTarget).data('href');
  }

  @on({ event: 'mouseenter', selector: 'tbody tr' })
  onHoverTr(e: any) {
    const currentRow = $(e.currentTarget);
    currentRow
      .next('tr')
      .children('td')
      .css('borderColor', color.white);
    currentRow.children('td').css('borderColor', color.white);
  }

  @on({ event: 'mouseleave', selector: 'tbody tr' })
  onLeaveTr(e: any) {
    const currentRow = $(e.currentTarget);
    currentRow.children('td').css('borderColor', color.lineGray);
    currentRow
      .next('tr')
      .children('td')
      .css('borderColor', color.lineGray);
  }
}
